import { FC } from "react";
import Select from "react-select";
import { Box, FormHelperText } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import muiVariables from "../../styles/mui-variables";
import SelectDropdownStyle from "./SelectDropdownStyle";
import { useTranslation } from "react-i18next";

interface SelectProps {
  name?: string;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  optionsData: BookingType[];
  className?: string;
  value?: BookingType;
  error?: boolean | undefined;
  helperText?: any;
  onChange?: (value: any) => void;
  handleAddVenue?: (value: any) => void;
  customStyle?: {};
  fixHeight?: string | undefined;
  labelWidth?: string | undefined;
}

const SelectDropdown: FC<SelectProps> = ({
  name,
  label,
  className,
  placeholder,
  defaultValue,
  isDisabled,
  isLoading,
  isClearable,
  isSearchable,
  optionsData,
  value,
  error,
  helperText,
  onChange,
  handleAddVenue,
  fixHeight,
  labelWidth,
  customStyle = {
    ...SelectDropdownStyle.customSelectStyles,
    menuList: (base: any) => ({
      ...base,
      padding: 0,
      fontSize: muiVariables.subHeadingFontSize,
      fontWeight: 400,
      border: `1px solid ${muiVariables.borderColor}`,
      boxShadow: "0px 40px 64px 0px rgba(12, 12, 12, 0.08)",
      height: fixHeight ? fixHeight : undefined,
    }),
  },
  ...props
}) => {
  const { t } = useTranslation()

  return (
    <Box sx={SelectDropdownStyle.mainBox}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {label && (
          <label
            style={{
              ...SelectDropdownStyle.selectLabel, width: labelWidth ? labelWidth : "",
            }}
          >
            {label}
          </label>
        )}
        {handleAddVenue && <label
          style={{
            ...SelectDropdownStyle.selectLabel,
            width: labelWidth ? labelWidth : "",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "5px"

          }}
          onClick={handleAddVenue}
        >
          <AddCircleOutlineIcon fontSize="small" />
          {t("addEventPage.addVenue")}
        </label>}
      </Box>
      <Select
        className="basic-single"
        classNamePrefix="select"
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        name={name}
        options={optionsData}
        styles={customStyle}
        placeholder={placeholder}
        onChange={onChange}
        value={value && Object.keys(value).length === 0 ? "" : value}
        {...props}
      />
      {
        error && (
          <FormHelperText sx={SelectDropdownStyle.errorMessage}>
            {error ? helperText : null}
          </FormHelperText>
        )
      }
    </Box >
  );
};

export default SelectDropdown;
